import * as Account from './components/AuthMethods/AuthMethods.css';
import * as DeleteAccountDialog from './components/DeleteAccountDialog/DeleteAccountDialog.css';
import * as InfoField from './components/AuthMethods/AuthMethod/AuthMethod.css';
import * as SocialAuth from './components/SocialAuth/SocialAuth.css';
import * as NextFlight from './components/NextFlight/NextFlight.css';
import * as ConfirmDialog from './components/AuthMethods/AuthDialog/AuthDialog.css';
import * as EmptyPage from './components/EmptyPage/EmptyPage.css';
export default {
    Account,
    DeleteAccountDialog,
    InfoField,
    SocialAuth,
    NextFlight,
    ConfirmDialog,
    EmptyPage
};
